'use es6';

import { debounce, pick } from 'underscore';
import * as actions from 'DesignData/actions/ActionTypes';
import { save } from 'DesignData/actions/UnifiedLayouts';
import { DEBOUNCE_DELAY } from 'DesignData/constants/Autosave';
const DEBOUNCED_AUTOSAVE_ACTIONS = pick(actions, ['LAYOUT_WIDGET_SPLIT', 'LAYOUT_WIDGET_ADD_WIDGET_BELOW', 'LAYOUT_WIDGET_DELETE', 'LAYOUT_WIDGET_DELETE_REVERT', 'LAYOUT_WIDGET_GROUP_TYPE_TRANSFORM', 'LAYOUT_WIDGET_GROUP_TYPE_TRANSFORM_REVERT', 'LAYOUT_WIDGET_EDIT', 'LAYOUT_WIDGET_EDIT_PARAMS', 'LAYOUT_WIDGET_EDIT_LANGUAGE_OVERRIDES', 'LAYOUT_WIDGET_ADD_SMART_RULE', 'LAYOUT_WIDGET_EDIT_SMART_RULE', 'LAYOUT_WIDGET_REMOVE_SMART_RULE', 'LAYOUT_WIDGET_EDIT_SMART_RULES', 'LAYOUT_WIDGET_EDIT_SMART_RULES_ORDER', 'LAYOUT_WIDGET_UPDATE_SMART_RULES', 'LAYOUT_WIDGET_REMOVE_SMART_RULES', 'LAYOUT_WIDGET_SWAP', 'LAYOUT_WIDGET_CLONE', 'LAYOUT_CELL_UNGROUP', 'LAYOUT_DND_MOVE_WIDGET_WITHIN_ROW', 'LAYOUT_DND_MOVE_WIDGET_TO_NEW_ROW', 'LAYOUT_DND_MOVE_WIDGET_AND_CREATE_CELL', 'LAYOUT_DND_HORIZONTAL_RESIZE_WIDGETS', 'LAYOUT_DND_INSERT_SIDEBAR_WIDGET_IN_ROW', 'LAYOUT_DND_INSERT_SIDEBAR_WIDGET_AND_CREATE_CELL', 'LAYOUT_DND_MOVE_ROW', 'LAYOUT_DND_MOVE_WIDGET_AND_CREATE_ROW', 'LAYOUT_DND_MOVE_SIDEBAR_WIDGET_AND_CREATE_ROW', 'LAYOUT_EDIT_UNDO', 'LAYOUT_EDIT_REDO', 'LAYOUT_TOGGLE_EMAIL_TYPE', 'LAYOUT_GROUPING_CREATE', 'LAYOUT_TOGGLE_IS_AVAILABLE_FOR_NEW_CONTENT', 'LAYOUT_LOCALIZATION_DELETE_LANGUAGE', 'LAYOUT_LOCALIZATION_CHANGE_MASTER_LANGUAGE', 'LAYOUT_LOCALIZATION_OPT_IN', 'LAYOUT_LOCALIZATION_ADD_LANGUAGE']);
const AUTOSAVE_ACTIONS = pick(actions, ['LAYOUT_PROPERTIES_EDIT', 'LAYOUT_REVERT']);

function saveLayout(dispatch, layoutId) {
  dispatch(save(layoutId));
}

const debouncedSave = debounce(saveLayout, DEBOUNCE_DELAY);
export default (({
  dispatch
}) => next => action => {
  const result = next(action);
  const {
    layoutId,
    silent
  } = result;

  if (layoutId && !silent) {
    if (DEBOUNCED_AUTOSAVE_ACTIONS[result.type]) {
      debouncedSave(dispatch, layoutId);
    } else if (AUTOSAVE_ACTIONS[result.type]) {
      saveLayout(dispatch, layoutId);
    }
  }

  return result;
});